import { MentorQueuesData } from "../../types";
import { mentorInitialState } from "../../../Shared/Redux/Reducers/mentorAccessReducer";
import { apiErrorInitialState } from "../../../Shared/Redux/Reducers/apiErrorReducer";
import { apiCallsInitialState } from "../../../Shared/Redux/Reducers/apiStatusReducer";

export default {
    queuedMentors: [],
    activeMentors: [],
    completedMentors: [],
    assignedMentors: [],
    upcomingMentors: [],
    waitingForSignOff: [],
    apiCallsInProgress: apiCallsInitialState,
    localizations: null as any,
    mentorAccess: mentorInitialState.mentorAccess,
    userInfo: null as any,
    apiError: apiErrorInitialState.apiError,
} as MentorQueuesData;
